@let hidden = problem().hidden;

<button
    class="btn btn-outline-secondary px-2 text-nowrap w-100"
    (click)="onToggleHidden()"
    [attr.aria-label]="hidden ? 'Mark as visible' : 'Mark as hidden'"
    i18n-aria-label
>
    <fa-icon
        [icon]="hidden ? faEye : faEyeSlash"
        aria-hidden="true"
    ></fa-icon>
    <span class="ms-2">
        @if (hidden) {
        <ng-container i18n>Show</ng-container>
        } @else {
        <ng-container i18n>Hide</ng-container>
        }
    </span>
</button>

